import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import '../styles/Header.css'

const BASE_URL = 'https://api.yourhood.ge'

function Header({ cartCount = 0, onCategorySelect, selectedCategory, onSearch }) {
  const [searchOpen, setSearchOpen] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [menuOpen, setMenuOpen] = useState(false)
  const [categories, setCategories] = useState([])
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [sidebarCatOpen, setSidebarCatOpen] = useState(false)
  const closeTimer = useRef(null)
  const dropdownRef = useRef(null)
  const navigate = useNavigate()

  useEffect(() => {
    fetch(`${BASE_URL}/api/Categories/categories`, {
      headers: { 'X-Language': 'ka' }
    })
      .then(res => res.json())
      .then(data => setCategories(data))
      .catch(err => console.error('Categories error:', err))
  }, [])

  const openDropdown = () => {
    clearTimeout(closeTimer.current)
    setDropdownOpen(true)
  }

  const closeDropdown = () => {
    closeTimer.current = setTimeout(() => {
      setDropdownOpen(false)
    }, 200)
  }

  const scrollToProducts = () => {
    setTimeout(() => {
      document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })
    }, 100)
  }

  const handleSearchIconClick = () => {
    setSearchOpen(prev => {
      if (!prev) scrollToProducts()
      return !prev
    })
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    if (onSearch) onSearch(searchValue)
    setSearchOpen(false)
    navigate('/')
    scrollToProducts()
  }

  const handleSearchClose = () => {
    setSearchOpen(false)
    setSearchValue('')
    if (onSearch) onSearch('')
  }

  const handleCategory = (id) => {
  if (onCategorySelect) onCategorySelect(id)
  navigate('/')
  setMenuOpen(false)
  scrollToProducts()
}

  return (
    <>
      <header className="header">
        <div className="header-logo" onClick={() => navigate('/')}>
          Your Hood
        </div>

        {/* ── Center Nav ── */}
        <nav className="header-nav">
          <a className="header-link" onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }) }}>მთავარი</a>

          <div
            className={`header-dropdown ${dropdownOpen ? 'header-dropdown--open' : ''}`}
            ref={dropdownRef}
            onMouseEnter={openDropdown}
            onMouseLeave={closeDropdown}
          >
            <button className={`header-link header-dropdown-trigger ${dropdownOpen ? 'header-link--active' : ''}`}>
              კატეგორიები
              <svg className="dropdown-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            <div className="dropdown-panel" onMouseEnter={openDropdown} onMouseLeave={closeDropdown}>
              <div className="dropdown-inner">
                <button
                  className={`dropdown-item ${!selectedCategory ? 'dropdown-item--active' : ''}`}
                  onClick={() => handleCategory(null)}
                >
                  <span className="dropdown-item-text">ყველა</span>
                  <span className="dropdown-item-line" />
                </button>
                {categories.map((cat, i) => (
                  <button
                    key={cat.id}
                    className={`dropdown-item ${selectedCategory === cat.id ? 'dropdown-item--active' : ''}`}
                    onClick={() => handleCategory(cat.id)}
                    style={{ animationDelay: `${i * 0.04}s` }}
                  >
                    <span className="dropdown-item-text">{cat.title}</span>
                    <span className="dropdown-item-line" />
                  </button>
                ))}
              </div>
            </div>
          </div>

          <a className="header-link" onClick={() => navigate('/about')}>ჩვენს შესახებ</a>
          <a className="header-link" onClick={() => navigate('/contact')}>კონტაქტი</a>
        </nav>

        {/* ── Actions ── */}
        <div className="header-actions">
          <button className="header-icon-btn" onClick={handleSearchIconClick} aria-label="Search">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="11" cy="11" r="7" />
              <line x1="16.5" y1="16.5" x2="22" y2="22" />
            </svg>
          </button>

          <button className="header-icon-btn cart-btn" onClick={() => navigate('/basket')} aria-label="Cart">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 01-8 0" />
            </svg>
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </button>

          <button
            className={`header-icon-btn burger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </header>

      {/* ── Search Bar ── */}
      <div className={`search-bar ${searchOpen ? 'search-bar--open' : ''}`}>
        <form onSubmit={handleSearchSubmit} className="search-form">
          <input
            type="text"
            className="search-input"
            placeholder="მოძებნე პროდუქტი..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            autoFocus={searchOpen}
          />
          <button type="submit" className="search-submit">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="11" cy="11" r="7" />
              <line x1="16.5" y1="16.5" x2="22" y2="22" />
            </svg>
          </button>
          <button type="button" className="search-close" onClick={handleSearchClose}>✕</button>
        </form>
      </div>

      {/* ── Overlay ── */}
      {menuOpen && <div className="sidebar-overlay" onClick={() => setMenuOpen(false)} />}

      {/* ── Sidebar ── */}
      <div className={`sidebar ${menuOpen ? 'sidebar--open' : ''}`}>

        <div className="sidebar-top">
          <div className="sidebar-logo" onClick={() => { navigate('/'); setMenuOpen(false) }}>
            YourHood
          </div>
          <button className="sidebar-close" onClick={() => setMenuOpen(false)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <nav className="sidebar-nav">

          <a className="sidebar-link" onClick={() => { navigate('/'); setMenuOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }) }}>
            <span>მთავარი</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>

          <div className="sidebar-accordion">
            <button
              className={`sidebar-link sidebar-accordion-btn ${sidebarCatOpen ? 'sidebar-accordion-btn--open' : ''}`}
              onClick={() => setSidebarCatOpen(prev => !prev)}
            >
              <span>კატეგორიები</span>
              <svg
                className={`sidebar-chevron ${sidebarCatOpen ? 'sidebar-chevron--open' : ''}`}
                width="14" height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            <div className={`sidebar-cat-panel ${sidebarCatOpen ? 'sidebar-cat-panel--open' : ''}`}>
              <button
                className={`sidebar-cat-item ${!selectedCategory ? 'sidebar-cat-item--active' : ''}`}
                onClick={() => handleCategory(null)}
              >
                {!selectedCategory && <span className="sidebar-cat-dot" />}
                ყველა
              </button>
              {categories.map(cat => (
                <button
                  key={cat.id}
                  className={`sidebar-cat-item ${selectedCategory === cat.id ? 'sidebar-cat-item--active' : ''}`}
                  onClick={() => handleCategory(cat.id)}
                >
                  {selectedCategory === cat.id && <span className="sidebar-cat-dot" />}
                  {cat.title}
                </button>
              ))}
            </div>
          </div>

          <a className="sidebar-link" onClick={() => { navigate('/about'); setMenuOpen(false) }}>
            <span>ჩვენს შესახებ</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>

          <a className="sidebar-link" onClick={() => { navigate('/contact'); setMenuOpen(false) }}>
            <span>კონტაქტი</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>

        </nav>

        <div className="sidebar-footer">
          <span className="sidebar-footer-text">© 2025 YourHood</span>
        </div>

      </div>
    </>
  )
}

export default Header